if (!customElements.get('shipping-calculator')) {
  class ShippingCalculator extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.button.addEventListener('click', this.handleSubmit.bind(this));
      this.zip = this.querySelector('.js-zip-input');
    }

    init() {
      this.country = this.querySelector('.js-country-select');
      this.province = this.querySelector('.js-province-select');
      this.zip = this.querySelector('.js-zip-input');
      this.rates = this.querySelector('.js-rates');
      this.errors = this.querySelector('.js-errors');
      this.initialised = true;
      this.zipCodeRange = [{province:"SP",from:1e6,to:19999999},{province:"RJ",from:2e7,to:28999999},{province:"ES",from:29e6,to:29999999},{province:"MG",from:3e7,to:39999999},{province:"BA",from:4e7,to:48999999},{province:"SE",from:49e6,to:49999999},{province:"PE",from:5e7,to:56999999},{province:"AL",from:57e6,to:57999999},{province:"PB",from:58e6,to:58999999},{province:"RN",from:59e6,to:59999999},{province:"CE",from:6e7,to:63999999},{province:"PI",from:64e6,to:64999999},{province:"MA",from:65e6,to:65999999},{province:"PA",from:66e6,to:68899999},{province:"AP",from:689e5,to:68999999},{province:"AM",from:69e6,to:69299999},{province:"RR",from:693e5,to:69399999},{province:"AM",from:694e5,to:69899999},{province:"AC",from:699e5,to:69999999},{province:"DF",from:7e7,to:72799999},{province:"GO",from:728e5,to:72999999},{province:"DF",from:73e6,to:73699999},{province:"GO",from:737e5,to:76799999},{province:"RO",from:768e5,to:76999999},{province:"TO",from:77e6,to:77999999},{province:"MT",from:78e6,to:78899999},{province:"MS",from:79e6,to:79999999},{province:"PR",from:8e7,to:87999999},{province:"SC",from:88e6,to:89999999},{province:"RS",from:9e7,to:99999999}]
    }

    /**
     * Handles submission of the rates calculator.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      evt.preventDefault();
      if (!this.initialised) this.init();

      this.errors.hidden = true;
      this.rates.hidden = true;
      this.button.disabled = true;
      this.button.querySelector('.loading__spinner').classList.remove('hidden');
      this.button.querySelector('.button-text').classList.add('hidden');

      // Busca a província usando o zipCodeRange em vez do ViaCEP
      const cep = parseInt(this.zip.value.replace(/\D/g, ''));
      let province = this.province.value;
      
      // Procura o CEP na tabela de faixas de CEP
      const foundRange = this.zipCodeRange.find(range => cep >= range.from && cep <= range.to);
      
      if (foundRange) {
        province = foundRange.province;
      }

      const params = `shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.country.value}&shipping_address[province]=${province}`;

      try {
        const response = await fetch(`${theme.routes.cart}/shipping_rates.json?${params}`);
        const data = await response.json();

        if (response.ok) {
          this.showRates(data);
        } else {
          this.showErrors(data);
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
      } finally {
        this.button.querySelector('.loading__spinner').classList.add('hidden');
        this.button.querySelector('.button-text').classList.remove('hidden');
        this.button.disabled = false;
      }
    }

    /**
     * Formats and shows a list of available shipping rates.
     * @param {object} data - Response data.
     */
    showRates(data) {
      const headingEl = this.rates.querySelector('.js-rates-heading');
      const textEl = this.rates.querySelector('.js-rates-text');
      textEl.innerHTML = '';

      if (data.shipping_rates && data.shipping_rates.length) {
        const headingLocaleStr = data.shipping_rates.length === 1 ? 'singleRate' : 'multipleRates';
        let rates = '';

        data.shipping_rates.forEach((rate) => {
          let formattedRate;
          if (rate.price > 0) {
            formattedRate = rate.currency === 'BRL' 
              ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(rate.price) 
              : theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, rate.price);
          } else {
            formattedRate = 'Frete Grátis'
          }

          let name = rate.name;

          if (rate.name === 'Local Delivery') {
            name = 'Entrega Local';
          }

          rates += `<li><p>${name}: <b>${formattedRate}</b><br /><small>${rate.delivery_days[0] !== undefined ? `em até ${rate.delivery_days[0]} dias úteis` : `${rate.description}`}</small></p></li>`;
        });

        headingEl.hidden = false;
        headingEl.textContent = theme.strings.shippingCalculator[headingLocaleStr];
        textEl.innerHTML = `<ul class="styled-list">${rates}</ul>`;
      } else {
        headingEl.hidden = true;
        textEl.innerHTML = theme.strings.shippingCalculator.noRates;
      }

      this.rates.hidden = false;
    }

    /**
     * Formats and shows errors relating to rates retrieval.
     * @param {object} data - Response data.
     */
    showErrors(data) {
      let errors = '';

      Object.keys(data).forEach((key) => {
        errors += `<li>${data[key]}</li>`;
      });

      this.errors.querySelector('.js-errors-text').innerHTML = `<ul class="styled-list">${errors}</ul>`;
      this.errors.hidden = false;
    }
  }

  customElements.define('shipping-calculator', ShippingCalculator);
}
